import PropTypes from 'prop-types';

export const customIconsPropTypes = {
  fontSize: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string,
  sx: PropTypes.node,
};
